import Form from 'components/FormFactory/Form';
import { Form as AntForm } from 'antd';

const create = (createFormProps) => AntForm.create(createFormProps)(Form);

export default create;